var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "info-wrapper" },
    [
      _vm.sale.Contact
        ? _c(
            "w-card",
            { staticClass: "card" },
            [
              _c(
                "w-card-title",
                { class: { "small-title": _vm.$wf.isMdDown } },
                [
                  _vm.sale.Contact.Info != "" || _vm.displayExtraFields
                    ? _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("contact-info"),
                              expression: "$ct('contact-info')",
                            },
                          ],
                          staticClass: "mt mrs info-circle",
                          attrs: { round: "", sm: "" },
                          on: {
                            click: function ($event) {
                              _vm.contactInfoModal = !_vm.contactInfoModal
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "info" } })],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "contact-info",
                      on: {
                        mouseenter: _vm.onContactEnter,
                        mouseleave: _vm.scheduleHideHoverCard,
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.sale.Contact.getDisplayName()) + " "
                      ),
                      _c("div", { staticClass: "smaller" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.moreText) +
                            " " +
                            _vm._s(
                              _vm.$ct(
                                _vm.sale.Contact.GroupID == 3
                                  ? "prospect-id"
                                  : "contact-id"
                              )
                            ) +
                            " " +
                            _vm._s(_vm.sale.Contact.ComputedFriendlyID) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "contact-hover-card",
                          class: { visible: _vm.showHoverCard },
                          style: _vm.hoverCardStyle,
                          on: {
                            mouseenter: _vm.clearHideHoverCard,
                            mouseleave: _vm.scheduleHideHoverCard,
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "hover-name" }, [
                            _vm._v(_vm._s(_vm.sale.Contact.getDisplayName())),
                          ]),
                          _vm.hoverAddressLines.length
                            ? _c(
                                "div",
                                { staticClass: "hover-address" },
                                _vm._l(
                                  _vm.hoverAddressLines,
                                  function (line, i) {
                                    return _c("div", { key: i }, [
                                      _vm._v(_vm._s(line)),
                                    ])
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "hover-row" },
                            [
                              _c("w-fa", {
                                staticClass: "hover-icon",
                                attrs: { icon: "hashtag" },
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$ct(
                                      _vm.sale.Contact.GroupID == 3
                                        ? "prospect-id"
                                        : "contact-id"
                                    )
                                  ) +
                                    " " +
                                    _vm._s(_vm.sale.Contact.ComputedFriendlyID)
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm.hoverEmail
                            ? _c(
                                "a",
                                {
                                  staticClass: "hover-row link",
                                  attrs: { href: "mailto:" + _vm.hoverEmail },
                                },
                                [
                                  _c("w-fa", {
                                    staticClass: "hover-icon",
                                    attrs: { icon: "envelope" },
                                  }),
                                  _c("span", [_vm._v(_vm._s(_vm.hoverEmail))]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.sale.Contact.MainAddress &&
                          _vm.sale.Contact.MainAddress.Phone
                            ? _c(
                                "a",
                                {
                                  staticClass: "hover-row link",
                                  attrs: {
                                    href: _vm.sale.Contact.getCleanPhone(),
                                  },
                                },
                                [
                                  _c("w-fa", {
                                    staticClass: "hover-icon",
                                    attrs: { icon: "phone" },
                                  }),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.sale.Contact.MainAddress.Phone)
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.sale.Contact.MainAddress &&
                          _vm.sale.Contact.MainAddress.Mobile
                            ? _c(
                                "a",
                                {
                                  staticClass: "hover-row link",
                                  attrs: {
                                    href: _vm.sale.Contact.getCleanMobile(),
                                  },
                                },
                                [
                                  _c("w-fa", {
                                    staticClass: "hover-icon",
                                    attrs: { icon: "mobile-alt" },
                                  }),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.sale.Contact.MainAddress.Mobile
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.sale.Contact.Vat
                            ? _c(
                                "div",
                                { staticClass: "hover-row" },
                                [
                                  _c("w-fa", {
                                    staticClass: "hover-icon",
                                    attrs: { icon: "building" },
                                  }),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$ct("vat-number")) +
                                        " " +
                                        _vm._s(_vm.sale.Contact.Vat)
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                  _vm.$wf.isLgUp ? _c("w-spacer") : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "dates",
                      class: { xs: _vm.$wf.isXs, lg: _vm.$wf.isLgUp },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "sale-info",
                          style: { marginRight: "25px" },
                        },
                        [
                          _c("div", { staticClass: "more" }, [
                            _vm._v(_vm._s(_vm.$ct("created"))),
                          ]),
                          _vm._v(
                            _vm._s(
                              _vm.sale.InvoiceDate.toLocaleDateString("nl-be", {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                              })
                            ) + " "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "sale-info",
                          style: { marginRight: "25px" },
                        },
                        [
                          _c("div", { staticClass: "more" }, [
                            _vm._v(_vm._s(_vm.$ct("date-end"))),
                          ]),
                          _vm._v(
                            _vm._s(
                              _vm.sale.ExpirationDate.toLocaleDateString(
                                "nl-be",
                                {
                                  year: "numeric",
                                  month: "2-digit",
                                  day: "2-digit",
                                }
                              )
                            ) + " "
                          ),
                        ]
                      ),
                      _vm.sale.TypeID < 3 && _vm.sale.TotalOpen != 0
                        ? _c("div", { staticClass: "sale-info open" }, [
                            _c("div", { staticClass: "more" }, [
                              _vm._v(_vm._s(_vm.$ct("open-amount"))),
                            ]),
                            _c("span", {}, [
                              _vm._v(
                                _vm._s(
                                  _vm.humanFloat(
                                    _vm.sale.TotalOpen / _vm.sale.CurrencyRate
                                  )
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
              _vm.$wf.isMdUp
                ? _c("app-products-table-info", {
                    attrs: { items: _vm.sale.Rows, sale: _vm.sale },
                  })
                : _c(
                    "w-scroll-view",
                    { attrs: { tag: "w-list" } },
                    _vm._l(_vm.sale.Rows, function (row) {
                      return _c(
                        "div",
                        { key: row.ID, staticClass: "sale-row" },
                        [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              " " +
                                _vm._s(row.Amount) +
                                ": " +
                                _vm._s(row.ProductSku) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "info" }, [
                            _c("div", { staticClass: "description" }, [
                              _vm._v(_vm._s(row.ProductDescription)),
                            ]),
                            _c("div", { staticClass: "tiny" }, [
                              _vm._v(
                                "€ " +
                                  _vm._s(
                                    _vm.humanFloat(
                                      row.UnitPrice / _vm.sale.CurrencyRate
                                    )
                                  ) +
                                  "/" +
                                  _vm._s(row.UnitName || _vm.$ct("qty"))
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "prices" }, [
                            _c("div", { staticClass: "price" }, [
                              _vm._v(
                                " € " +
                                  _vm._s(
                                    _vm.humanFloat(
                                      row.NettoPrice / _vm.sale.CurrencyRate
                                    )
                                  ) +
                                  " "
                              ),
                              _c("div", { staticClass: "tiny" }, [
                                _vm._v(_vm._s(_vm.$ct("netto"))),
                              ]),
                            ]),
                            _c("div", { staticClass: "price" }, [
                              _vm._v(
                                " " + _vm._s(_vm.humanFloat(row.Vat)) + " "
                              ),
                              _c("div", { staticClass: "tiny" }, [
                                _vm._v(_vm._s(_vm.$ct("vat"))),
                              ]),
                            ]),
                            _c("div", { staticClass: "price" }, [
                              _vm._v(
                                " € " +
                                  _vm._s(
                                    _vm.humanFloat(
                                      row.BrutoPrice / _vm.sale.CurrencyRate +
                                        row.LeeggoedTax * row.Amount
                                    )
                                  ) +
                                  " "
                              ),
                              _c("div", { staticClass: "tiny" }, [
                                _vm._v(_vm._s(_vm.$ct("bruto"))),
                              ]),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
            ],
            1
          )
        : _vm._e(),
      _c("app-totals", {
        attrs: { totalable: _vm.sale, "toggle-profit": _vm.profitVisible },
      }),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.contactInfoModal,
            callback: function ($$v) {
              _vm.contactInfoModal = $$v
            },
            expression: "contactInfoModal",
          },
        },
        [
          _c("app-contact-info-modal", {
            attrs: {
              contact: _vm.sale.Contact,
              "client-stats": _vm.clientStats,
            },
            on: {
              cancel: function ($event) {
                _vm.contactInfoModal = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }